import { IFilterParams } from 'ag-grid-community';
import { get } from 'lodash';
import { forwardRef, useImperativeHandle, useRef } from 'react';

interface PriceOfferSingleValueFilterModel {
  filter?: string | number | null;
}

/**
 * Normalizes unknown filter values to the string shape used by select filters.
 */
const normalizeValue = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  return String(value);
};

/**
 * Parent filter for select filters that store an id while the column displays a label.
 */
const PriceOfferSingleValueColumnFilter = forwardRef(({ filterChangedCallback, colDef }: IFilterParams, ref) => {
  const value = useRef<string | null>(null);

  useImperativeHandle(ref, () => ({
    doesFilterPass({ data }: { data: Record<string, unknown> }) {
      if (value.current === null) {
        return true;
      }

      return String(get(data, colDef.field ?? '')) === value.current;
    },

    getModel() {
      if (value.current === null) {
        return null;
      }

      return { filter: value.current };
    },

    setModel(model: PriceOfferSingleValueFilterModel | null) {
      value.current = normalizeValue(model?.filter);
    },

    isFilterActive() {
      return value.current !== null;
    },

    onFloatingFilterChanged(newValue: string | number | null) {
      const normalizedValue = normalizeValue(newValue);

      if (value.current !== normalizedValue) {
        value.current = normalizedValue;
        filterChangedCallback();
      }
    },
  }));

  return <></>;
});

export default PriceOfferSingleValueColumnFilter;
